export default "__VITE_ASSET__Byx2rBsB__"